import { Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import GraphContainer from "./GraphContainer";

// fetch average resolution times per week from JSON file
async function fetchResolutionTimes() {
  try {
    const res = await fetch("data/resolution-time.json"); // placeholder data
    if (!res.ok)
      console.error(
        "Error fetching resolution times, did not return 200 response"
      );
    const json = await res.json();
    return json;
  } catch (error) {
    console.error("Error fetching resolution time: ", error);
  }
}

export default function ResolutionTimeGraph() {
  const [resolutionTimes, setResolutionTimes] = useState(null);

  useEffect(() => {
    fetchResolutionTimes().then((resTime) => setResolutionTimes(resTime));
  }, []);

  if (!resolutionTimes) return <Typography variant="p">Loading...</Typography>;

  return (
    <GraphContainer header={"Average Resolution Time"}>
      <BarChart
        dataset={resolutionTimes}
        xAxis={[
          {
            dataKey: "week",
            scaleType: "band",
            label: "Week Starting On",
          },
        ]}
        series={[
          {
            dataKey: "timeToResolve",
            valueFormatter: (value) => `${value} minutes`,
          },
        ]}
      />
    </GraphContainer>
  );
}
